<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-01-21 09:39:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/list/components/BottomBtn/index.vue
-->
<template>
  <div>
    <div class="clearfix bottom_brn border_top1px">
      <!-- <div v-if="item.status === 10" class="left">
      <div
        class="font12 font_weight500 colo087 line_height_14 totle_price text_left"
      >
        总计：{{ item.total | currency(false) }}
      </div>
      <div
        v-if="false"
        class="font12 font_weight500 colo038 line_height_14 free_price text_left"
      >
        已优惠：{{ item.taxMoney | currency(false) }}
      </div>
    </div> -->
      <div
        v-if="i.afterInfo"
        class="left font12 font_weight500 colof00 line_height_14 refund_det text_left"
      >
        {{ i.afterInfo }}
      </div>
      <div class="right right_btn">
        <div
          v-for="(btn, index) in btnList"
          :key="index"
          :class="{
            pay_btn: btn.isLightHeight,
            colof: btn.isLightHeight,
            btn_mr: index !== 0
          }"
          class="cancel_btn colo087 font12 font_weight400 line_height_30"
          @click="clickBtn(btn.name)"
        >
          {{ btn.name }}
        </div>
        <!-- <div class="pay_btn font12 font_weight500 colof line_height_30 btn_mr">
        去付款
      </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    i: {
      type: Object,
      default() {
        return {};
      }
    },
    packageIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  filters: {
    // 订单包裹的售后状态
    refunDet(status) {
      switch (status) {
        case 1:
          return "订单受理中";
        case 2:
          return "订单受理中";
        case 3:
          return "订单受理中";
        case 4:
          return "订单受理中";
        case 5:
          return "订单受理中";
      }
    }
  },
  methods: {
    clickBtn(name) {
      this.$emit(
        "clickBtn",
        name,
        this.item.orderSn,
        this.i.subOrderSn,
        this.packageIndex,
        this.item.orderType,
        this.i.spuId,
        this.item
      );
    }
  }
};
</script>
<style lang="less" scoped>
.bottom_brn {
  padding-bottom: 9px;
  margin: 0 12px 0 12px;
  .totle_price {
    margin-top: 18px;
  }
  .free_price {
    margin-top: 2px;
  }
  .right_btn {
    margin-top: 8px;
    display: flex;
    .cancel_btn {
      width: 84px;
      border-radius: 2px;
      border: 1px solid #000;
    }
    .btn_mr {
      margin-left: 8px;
    }
    .pay_btn {
      width: 84px;
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 2px;
      border: 0;
    }
  }
  .refund_det {
    padding: 14px 0 5px;
  }
}
</style>
